import abi from './transactions.json';

export const contractAbi = abi.abi;
export const contractAddress = '0x5667AEEA3B767f4C356d71A06A82DE2677F874ff';
